import moment from 'moment'

export const knowDataOptions = [
  {
    id: 'doctor',
    label: 'แพทย์ / บุลคลากรทางการแพทย์',
    hasInput: true,
  },
  { id: 'lineOA', label: 'Line OA', hasInput: false },
  { id: 'friend', label: 'เพื่อน / ญาติ', hasInput: false },
  { id: 'youtube', label: 'YouTube', hasInput: false },
  { id: 'teacher', label: 'ครู / โรงเรียน', hasInput: true },
  { id: 'tiktok', label: 'TikTok', hasInput: false },
  { id: 'facebook', label: 'Facebook / Inbox', hasInput: false },
  { id: 'instagram', label: 'Instagram', hasInput: false },
  { id: 'messenger', label: 'Messenger', hasInput: false },
  {
    id: 'advertising',
    label: 'ป้ายโฆษณา / ขับรถผ่าน / Walk in',
    hasInput: false,
  },
  { id: 'google', label: 'Google', hasInput: false },
  { id: 'other', label: 'อื่นๆ', hasInput: true },
  { id: 'website', label: 'Website', hasInput: false },
]

export const calculateAge = (birthday) => {
  const totalMonths = moment().diff(moment(birthday, 'YYYY-MM-DD'), 'months')
  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12
  if (years > 0) {
    return `${years} ปี ${months} เดือน`
  } else {
    return `${months} เดือน`
  }
}

export const getKnowKids = ({
  kidKnow,
  knowOptions = knowDataOptions,
  kidFrom,
}) => {
  const selectedItems = Object.entries(kidKnow)
    .filter(([_, value]) => value.selected === true)
    .map(([id, value]) => {
      const option = knowOptions.find((opt) => opt.id === id)
      if (!option) return ''

      if (value.detail) {
        // return `${option.label} (${value.detail})`
        return `${value.detail}`
      }
      return option.label
    })
    .filter(Boolean)
    .join(', ')

  const fromKids = kidFrom ? kidFrom : ''
  const knowKidsPlus =
    selectedItems.length > 0 && fromKids.length > 0
      ? // ? `${selectedItems}, ${fromKids}`
        `${selectedItems}`
      : selectedItems.length > 0
      ? selectedItems
      : fromKids.length === 0 && selectedItems.length === 0
      ? '-'
      : fromKids

  return knowKidsPlus
}
